import React from 'react';
import { Helmet } from 'react-helmet';

class GoogleTagManager extends React.Component {
  componentDidMount() {
    const gtmId = "GTM-NNV8B9VW";
    if (typeof window !== 'undefined' && this.checkConsentCookie()) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', gtmId);
    }
  }

  checkConsentCookie() {
    if (typeof window !== 'undefined') {
      const cookies = document.cookie.split(';').map(cookie => cookie.trim());
      for (let cookie of cookies) {
        const [key, value] = cookie.split('=');
        if (key === 'cookies_consent' && value === 'true') {
          return true;
        }
      }
    }
    return false;
  }

  render() {
    const { gtmId } = this.props;
    const hasConsent = this.checkConsentCookie();
    return (
      <>
        {hasConsent && (
          <Helmet>
            <script>
              {`
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-NNV8B9VW');
              `}
            </script>
          </Helmet>
        )}
        {hasConsent && (
          <noscript>
            <iframe src={`https://www.googletagmanager.com/ns.html?id=GTM-NNV8B9VW`}
              height="0" width="0" style={{ display: 'none', visibility: 'hidden' }}>
            </iframe>
          </noscript>
        )}
      </>
    );
  }
}

export default GoogleTagManager;
